import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { SvgLoading, TYPES } from 'sarsaparilla';
import { get } from 'lodash';
import TertiaryContent from '../../../ui-permit/src/components/TertiaryContent';
import * as pActions from '../actions/permit';

const propTypes = {
  match: TYPES.MATCH,
  dispatch: PropTypes.func,
  id: PropTypes.string,
  name: PropTypes.string,
  additionalInformation: PropTypes.string
};

const defaultProps = {
  additionalInformation: "",
  id: "",
  name: ""
};

export class TertiaryContentPage extends Component {
  componentDidMount() {
    const { permitId } = this.props.match.params;
    if (permitId !== this.props.id) {
      this.refetchPermit(permitId);
    }
  }

  refetchPermit(permitId) {
    this.props.dispatch(pActions.fetchPermit(permitId));
  }

  render() {
    if (
      !this.props.id ||
      (this.props.match.params.permitId !== this.props.id)
    ) {
      return (
        <div className="permit-loading-wrapper">
          <SvgLoading />
        </div>
      );
    }
    return (
      <TertiaryContent
        id={this.props.id}
        name={this.props.name}
        additionalInformation={this.props.additionalInformation} />
    );
  }
}

TertiaryContentPage.propTypes = propTypes;
TertiaryContentPage.defaultProps = defaultProps;

function select(state) {
  return {
    id: get(state, 'inyonwhitney.permit.result.id'),
    name: get(state, 'inyonwhitney.permit.result.name'),
    additionalInformation: get(state, 'inyonwhitney.permit.result.description.tertiary_page')
  };
}

export default connect(select)(TertiaryContentPage);
